import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { GET_VARIAVEIS_GLOBAIS_INIT, UPDATE_VARIAVEIS_GLOBAIS_INIT } from '../../actionTypes';
import {
  getVariaveisGlobaisSuccess,
  atualizaVariaveisGlobaisSuccess,
  errorVariaveisGlobaisMsg
} from './actions';
import { obtemVariaveisGlobais, atualizarVariaveisGlobais } from 'src/integracoes/servicos/mongo-atlas/funcoes/variaveisGlobais';

function* fetchGetVariaveisGlobais() {
  try {
    const { status, dados, mensagem } = yield call(obtemVariaveisGlobais);
    if (status) {
      yield put(getVariaveisGlobaisSuccess({ variaveisGlobais: dados }));
    } else {
      yield put(errorVariaveisGlobaisMsg({ msg: mensagem }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorVariaveisGlobaisMsg({ msg: mensagem }));
  }
}

function* watchGetVariaveisGlobais() {
  yield takeEvery(GET_VARIAVEIS_GLOBAIS_INIT, fetchGetVariaveisGlobais);
}

function* fetchAtualizaVariaveisGlobais({ payload }: { payload: any; type: any }) {
  try {
    const { status, mensagem } = yield call(atualizarVariaveisGlobais, payload);
    if (status) {
      yield put(atualizaVariaveisGlobaisSuccess({ msg: mensagem }));
    } else {
      yield put(errorVariaveisGlobaisMsg({ msg: mensagem }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorVariaveisGlobaisMsg({ msg: mensagem }));
  }
}

function* watchAtualizaVariaveisGlobais() {
  yield takeEvery(UPDATE_VARIAVEIS_GLOBAIS_INIT, fetchAtualizaVariaveisGlobais);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetVariaveisGlobais),
    fork(watchAtualizaVariaveisGlobais)
  ]);
}
